module.exports = __webpack_public_path__ + "img/logo.31fbf6d9.png";